import THREEJS from "../3D/three";
import { BREAKPOINTS } from "../styles/variables/breakpoints";

const alignMeshToDom = (mesh, camera, domEl, canvasEl) => {
  if (!mesh || !camera || !domEl || !canvasEl) return;

  const target = domEl.getBoundingClientRect();
  const canvas = canvasEl.getBoundingClientRect();

  const marginX = window.innerWidth > BREAKPOINTS.xxl ? 1.35 : 1.25;
  const marginY = 0.5;

  const cx = target.left + target.width * marginX;
  const cy = target.top + target.height * marginY;

  const sx = ((cx - canvas.left) / canvas.width) * 2 - 1;
  const sy = ((cy - canvas.top) / canvas.height) * -2 + 1;

  const ndc = new THREEJS.Vector3(sx, sy, 0).unproject(camera);

  const dir = ndc.sub(camera.position).normalize();
  const dist = -camera.position.z / dir.z;
  mesh.position.copy(camera.position.clone().add(dir.multiplyScalar(dist)));
};

export { alignMeshToDom };
